import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { L } from '@lib';
import { Rules } from '@utils';
import { Button, Form, FormInstance, Input, Modal, Space, Typography } from 'antd';
import React, { useState } from 'react';

const { Text } = Typography;

interface IProps {
  form: FormInstance<any>;
  vatNumber?: string;
  handleUpdate: (values: any) => Promise<void>;
  handleDelete: () => void;
}

const GarageVatRegistration: React.FC<IProps> = ({ form, vatNumber, handleUpdate, handleDelete }) => {
  const [editing, setEditing] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      await handleUpdate(values);
      setEditing(false);
    } catch {
      // validation failed
    }
  };

  const handleCancel = () => {
    setEditing(false);
    form.setFieldsValue({ vatNumber });
  };

  if (editing || !vatNumber) {
    return (
      <>
        <Form form={form} initialValues={{ vatNumber }} component={false}>
          <Space size="small" align="start">
            <Form.Item name="vatNumber" rules={Rules.vat} style={{ marginBottom: 0 }}>
              <Input
                placeholder={L('Enter VAT registration number')}
                onPressEnter={handleSave}
                autoFocus
                style={{ width: 240 }}
              />
            </Form.Item>
            <Button type="text" icon={<CheckOutlined style={{ color: '#52c41a' }} />} onClick={handleSave} />
            {vatNumber && (
              <Button type="text" icon={<CloseOutlined style={{ color: 'rgba(0,0,0,0.45)' }} />} onClick={handleCancel} />
            )}
          </Space>
        </Form>
        <Modal
          title={L('Are you sure you want to delete the VAT registration number?')}
          open={showDeleteModal}
          okText={L('Yes, delete')}
          onOk={() => {
            handleDelete();
            setShowDeleteModal(false);
          }}
          onCancel={() => setShowDeleteModal(false)}
        />
      </>
    );
  }

  return (
    <>
      <Space size="small" align="center">
        <Text style={{ fontSize: 13, color: 'rgba(0, 0, 0, 0.45)' }}>{L('VAT Reg No:')}</Text>
        <Text style={{ fontSize: 14, fontWeight: 500 }}>{vatNumber}</Text>
        <Button
          type="text"
          size="small"
          icon={<EditOutlined style={{ color: '#2CBDFF' }} />}
          onClick={() => setEditing(true)}
        />
        <Button
          type="text"
          size="small"
          icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
          onClick={() => setShowDeleteModal(true)}
        />
      </Space>
      <Modal
        title={L('Are you sure you want to delete the VAT registration number?')}
        open={showDeleteModal}
        okText={L('Yes, delete')}
        onOk={() => {
          handleDelete();
          setShowDeleteModal(false);
        }}
        onCancel={() => setShowDeleteModal(false)}
      />
    </>
  );
};

export default GarageVatRegistration;
